export default __webpack_public_path__ + "static/media/egg_shaddow.96572a70.svg";